import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ShieldCheck, Star } from "lucide-react";

export default function Enterprises() {
  const [ents, setEnts] = useState([]);
  useEffect(() => { api.get("/enterprises").then(r => setEnts(r.data)); }, []);

  return (
    <div className="nx-container py-10">
      <span className="mono text-[11px] text-blue-700">WHOLESALE/DIRECTORY</span>
      <h1 className="text-4xl md:text-5xl font-black tracking-tighter mt-2 mb-3">Verified enterprises.</h1>
      <p className="text-slate-600 max-w-2xl mb-10">Direct-source from factories, mills and manufacturers across the globe. Every supplier is audited, certified, and rated.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {ents.map(e => (
          <div key={e.enterprise_id} data-testid={`enterprise-card-${e.enterprise_id}`} className="nx-card p-6">
            <div className="aspect-video bg-slate-100 mb-4 overflow-hidden">
              <img src={e.logo} alt="" className="w-full h-full object-cover" />
            </div>
            <div className="flex items-center gap-2 mb-2">
              <span className="mono text-[10px] text-slate-500">{e.country}</span>
              <span className="mono text-[10px] text-slate-500">·</span>
              <span className="mono text-[10px] text-slate-500">{e.years}Y</span>
              {e.verified && <span className="ml-auto nx-tag text-blue-700 border-blue-700"><ShieldCheck size={10} /> VERIFIED</span>}
            </div>
            <h3 className="font-black text-xl tracking-tight">{e.name}</h3>
            <p className="text-sm text-slate-600 mt-1">{e.specialty}</p>
            <div className="flex items-center gap-2 mt-3">
              <Star size={14} fill="#f59e0b" className="text-amber-500" />
              <span className="text-sm font-bold">{e.rating}</span>
              <span className="text-xs text-slate-500">supplier rating</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
